<div #typingContainer dir="auto" class="typing-text"></div>
@if (viewMode() === 'static') {
  <div #staticContainer class="regular-text" dir="auto" [innerHTML]="text() | safe: 'safeHtml'"></div>
}
